import { combineEpics } from 'redux-observable';
import { combineReducers } from 'redux';
import authentication from './slices/authenticationSlice';
import kpi from './slices/kpiSlice';
import genericViewSelector from './slices/genericViewSelectorSlice';
import status from './slices/statusSlice';
import {emptySplitApi} from "apis/api";

export const rootEpic = combineEpics(
);

export const rootReducer = combineReducers({
    authentication,
    kpi,
    genericViewSelector,
    status,
    [emptySplitApi.reducerPath]: emptySplitApi.reducer
});
